import { CustomTooltip } from '@/components/custom-tooltip';
import IconButton from '@mui/material/IconButton';
import copy from 'copy-to-clipboard';
import { Info } from 'lucide-react';
import { useState } from 'react';
import { Link } from 'react-router-dom';
import styles from '../../common/_variables.module.scss';
import { labels } from '../../locales/en.label';
import { Modal } from '../Modal/Modal';
import { useModal } from '../Modal/useModal';

export const AboutModal = () => {
	const { isShown, toggle } = useModal();
	const [copyMsg, setCopyMsg] = useState('click to copy');

	const handleCopy = () => {
		copy(`${labels.app.support_email}`);
		setCopyMsg('copied!');
		setTimeout(() => {
			setCopyMsg('click to copy');
		}, 2000);
	};

	const messageBody = (
		<ul>
			<li>
				<b>Name</b>: {labels.app.name}
			</li>
			<li>
				<b>Release</b>: {process.env.REACT_APP_VERSION}
			</li>
			<li>
				{' '}
				<b>Contact Support</b>
				<ul>
					<li>
						<a
							href={`mailto:${labels.app.support_email}?subject=BestREV2 Support`}
						>
							Email Support (Launch Mail Client)
						</a>
					</li>
					<li>
						<span onClick={handleCopy}>
							{labels.app.support_email} <b>{copyMsg}</b>
						</span>
					</li>
				</ul>
			</li>
			<li>
				<Link to='/changelog'>Code Changelog</Link>
			</li>
			<li>
				<Link to='/rate_changes'>Rate Change Logs</Link>
			</li>
			<li>
				<a
					href={'https://status.bestrev.bwhhotelgroup.com'}
					target='_blank'
					rel='noreferrer'
				>
					Status Page
				</a>
			</li>
		</ul>
	);

	return (
		<>
			<CustomTooltip content={<p>{labels.header.tooltip.about}</p>}>
				<IconButton
					disableFocusRipple
					disableRipple
					aria-label='info'
					onClick={toggle}
				>
					<Info size={20} className='header__icon' />
				</IconButton>
			</CustomTooltip>
			<Modal
				isShown={isShown}
				hide={toggle}
				headerText={labels.header.info_popup.header}
				onConfirm={toggle}
				onCancel={toggle}
				messageBody={messageBody}
				hasIcon={true}
				icon={<Info color={styles.colorGreen} />}
			/>
		</>
	);
};
